const state = {
    categories: [],
    subcategories:[],


}

const getters = {
    categories: state => state.categories,
    subcategories: state => state.subcategories,

}

const actions = {
   
    // LOGIN REGISTERED USER
    createSubCategories({commit},payload){
        firebase.database().ref('subcategories').push(payload)
        .then(()=>{
            commit("setNotifications",{message:'Sub Category created successfully',type:'success'})
        })
        .catch(error=>{
            commit("setNotifications",{message:error.message,type:'error'})
        })

    },
    createCategories({commit},payload){
        firebase.database().ref('categories').push(payload)
        .then(()=>{
            commit("setNotifications",{message:'Category created successfully',type:'success'})
        })
        .catch(error=>{
            commit("setNotifications",{message:error.message,type:'error'})
        })

    },
    fetchCategories({commit},payload){
        firebase.database().ref('categories').on('value', snapshot => {
            commit('setAllCategories', snapshot.val())
        })
    },
    fetchSubCategories({commit},payload){
        firebase.database().ref('subcategories').on('value', snapshot => {
            commit('setAllSubCategories', snapshot.val())
        })
    },
 
}

const mutations = {
    setAllCategories: (state, payload) => {
        let categories_Array=[]
        for(let key in payload) {
            payload[key].id=key
            categories_Array.push(payload[key])
        }
        state.categories=categories_Array
    },
    setAllSubCategories: (state, payload) => {
        let subcategories_Array=[]
        for(let key in payload) {
            payload[key].id=key
            subcategories_Array.push(payload[key])
        }
        state.subcategories=subcategories_Array
    }

    
   
}

export default {
    state,
    actions,
    getters,
    mutations
}